import secureAxios from '../secure_axios';

const baseUrl = 'mv'

async function servRefreshMvAll(dataInicio, dataFim) {
    const response = await secureAxios.get(
        `${baseUrl}/refresh-all`,
        {
            params: {
                dataInicio,
                dataFim
            }
        }
    )
    return response.data
}


export {
    servRefreshMvAll
}